import { Tooltip } from '@material-ui/core';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Store from '@apply/store';

const InProgressApplications = ({
    styles,
    formatApplicationDisplay,
    formatApplicationToolTip,
    formatApplicationDateTime,
    inProgressApplications,
}) => {
    return (
        <section style={styles.inProgressApplications}>
            <h4>In Progress Applications</h4>
            {inProgressApplications?.length > 0 && (
                <div>
                    <table>
                        <tbody>
                            {inProgressApplications.map((app, index) => (
                                <tr key={'inProg' + index}>
                                    <td>
                                        <Link
                                            to={`/borrower/${app.apiId}`}
                                            key={`application-link-${app.apiId}`}
                                        >
                                            {formatApplicationDisplay(app)}
                                        </Link>
                                    </td>
                                    <td align='right'>
                                        <Tooltip
                                            title={formatApplicationToolTip(app)}
                                            placement='right-end'
                                        >
                                            <Link
                                                to={`/borrower/${app.apiId}`}
                                                key={`application-link-${app.apiId}`}
                                            >
                                                <i>{formatApplicationDateTime(app)}</i>
                                            </Link>
                                        </Tooltip>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {!inProgressApplications?.length && (
                <ul style={styles.emptyApplications}>
                    <li>
                        <em>None</em>
                    </li>
                </ul>
            )}
        </section>
    );
};

export const mapStateToProps = (state: Store.ApplyRootStateType) => ({
    inProgressApplications: state.user?.inProgressApplications ?? [],
});

export default connect(mapStateToProps)(InProgressApplications);
